export default {
  signup: {},
  login: {},
  agreementStatus: false,
  categories: [],
  productState: [],
  mainProductState: [],
  singleProductAdminState: [],
  singleProductState: [],
  singleProductStatee: [],
  similarProducts: [],
  userModules: [],
  allModules: [
    "Performance",
    "Payment Gateway",
    "Domain",
    "Notifications",
    "Email Templates",
    "SMS Templates",
    "Version",
    "Admin Management",
    "Error Management",
    "Google Analytics",
    "Role Management",
    "Contact Us",
    "Marcom",
    "Branding",
    "Landing Page",
    "Builder",
    "User Management",
    "Studio",
    // ------------- Extensions -------------
    // "Ecommerce",
    // "Marketplace",
    // "Whatsapp Bot",
    // "E-Learning",
    // "OTT",
    // "Portfolio",
    // "Blog",
    // "Social",
    // "Booking Engine",
    // "Metaverse",
  ],
  roles: [],
  selectedPlan: "",
  myAddOns: [],
};
